// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store'; // Import store directly
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { DragDropContext } from 'react-beautiful-dnd';

// Add UI compatibility layer
function setupUICompatibilityLayer() {
  // Function to check if element should be visible based on class name and data attributes
  function shouldElementBeVisible(element) {
    // Try to determine if this is a UI container element 
    // (without hardcoding specific customer element names)
    const isContainer = element.classList.contains('course-nav') || 
                        element.classList.contains('container') || 
                        element.classList.contains('nav') ||
                        element.classList.contains('sidebar') ||
                        element.classList.contains('panel');
                        
    if (!isContainer) return null; // Not a UI container, don't interfere
    
    // Default behavior: UI containers should be visible
    return true;
  }

  // Create MutationObserver to watch for style changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
        
        const element = mutation.target;
        const visibility = shouldElementBeVisible(element);
        
        // Only intervene if we know this element should be visible
        if (visibility === true) {
          const style = window.getComputedStyle(element);
          
          // Check if the element is being hidden
          const isHidden = style.display === 'none' || 
                           style.visibility === 'hidden' || 
                           style.opacity === '0';
                           
          if (isHidden) {
            console.log('Ensuring visibility for UI element', element);
            
            // Force visibility but don't override other styles
            setTimeout(() => {
              // Use delay to ensure we execute after any other style changes
              if (element.style.display === 'none') element.style.display = '';
              if (element.style.visibility === 'hidden') element.style.visibility = '';
              if (element.style.opacity === '0') element.style.opacity = '';
            }, 0);
          }
        }
      }
    });
  });

  // Start observing when DOM is fully loaded
  window.addEventListener('DOMContentLoaded', () => {
    // Observe the entire document for changes
    observer.observe(document.body, { 
      attributes: true, 
      attributeFilter: ['style', 'class'],
      subtree: true, 
      childList: true 
    });
    
    console.log('UI compatibility layer initialized');
  });
}

// Initialize the UI compatibility layer
setupUICompatibilityLayer();

// Rest of your existing index.js code
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const onDragEnd = () => {
  // This is a no-op function for the root DragDropContext
  // The actual drag handling will be done in the CreateCourse component
};

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DragDropContext onDragEnd={onDragEnd}>
        <App />
      </DragDropContext>
    </ThemeProvider>
  </Provider>
);